module.exports = __webpack_public_path__ + "static/media/realtimetext-regular.e75cd248.woff2";